import { useMemo, useState } from 'react';
import { FormLabel, Grid } from '@material-ui/core';

import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import BreadCrumbs from '../../../Core/Controls/Breadcrumb';
import ReportGijgoGrid from '../ReportsScreens/GijgoForReportsScreen';
import EditIcon from '@material-ui/icons/Edit';
import { SquareButton } from '../../../Core/FormInput/AppButton';
import ReactDOM from 'react-dom';
import { LoanVehicleBooking } from '../..';
import DialogComp from '../../../Core/Modal/dialogModal';
import { useHistory } from 'react-router-dom';
import { getReportsSalesDropdownsResolveData } from '../../../Core/Service/reportService';
const baseColumns = [
    // { title: 'Action', field: 'action', width: 80, filterable: false },
    { field: 'registration', sortable: true, title: 'Loan Vehicle', width: 110 },
    { field: 'wipNumber', sortable: true, title: 'WIP No', width: 70 },
    {
        field: 'bn',
        sortable: true,
        title: 'Branch',
        width: 100,
        isDropDown: true,
        listIdFromAPIResponse: 'branchList',
        dropDownValueField: 'name',
        dropDownLableField: 'name'
    },
    { field: 'ccc', sortable: true, title: 'Customer', width: 180 },
    { field: 'dateOut', sortable: true, title: 'Handed Over', width: 120 },
    { field: 'dateIn', sortable: true, title: 'Returned', width: 120 },
    {
        field: 'edd',
        sortable: true,
        title: 'Days On Loan',
        width: 110,
        filterable: false,
        renderer: (value, record) => {
            const dateOut = record.dateOut ? new Date(record.dateOut) : null;
            const dateIn = record.dateIn ? new Date(record.dateIn) : new Date();

            if (!dateOut) return '-';

            const timeDiff = dateIn - dateOut;
            const daysOnLoan = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
            return daysOnLoan >= 0 ? daysOnLoan : '-';
        }
    },
    { field: 'companyDriverName', sortable: true, title: 'Driver Name', width: 150 },
    { field: 'ccn', sortable: true, title: 'Contact Name', width: 150 },
    { field: 'ccno', sortable: true, title: 'Contact No', width: 150 },
    { field: 'cce', sortable: true, title: 'Contact Email', width: 180 }
    // { field: 'ca', sortable: true, title: 'Contact Address', width: 200 },
    // { field: 'chassisNumber', sortable: true, title: 'Chassis No', width: 150 },
    // { field: 'mileageOut', sortable: true, title: 'Mileage Out', width: 120 },
    // { field: 'mileageIn', sortable: true, title: 'Mileage In', width: 120 },
    // { field: 'fuelOut', sortable: true, title: 'Fuel Out', width: 100 },
    // { field: 'fuelIn', sortable: true, title: 'Fuel In', width: 100 },
    // { field: 'vehicleModel', sortable: true, title: 'Vehicle Model', width: 120 },
    // { field: 'customerName', sortable: true, title: 'Customer Name', width: 180 }
];

const crumbs = () => {
    let list = [
        { name: 'Home', path: '/' },
        { name: 'Reports', active: true },
        { name: 'Loan Vehicle Usage', active: true }
    ];
    return list;
};

const useStyles = makeStyles((theme) => ({
    columnStyle: {
        cursor: 'pointer'
    }
}));

const LoanVehicleUsageList = (props) => {
    const history = useHistory();
    const classes = useStyles();

    const [state, setState] = useState({});

    const handleAddCust = (record) => {
        setState((st) => ({ ...st, showLoanVehicleUsage: true, selectedRecord: record }));
    };

    const closeLoanVehicleUsageModal = (record) => {
        setState((st) => ({ ...st, showLoanVehicleUsage: false, selectedRecord: {} }));
    };

    const registrationLVUHandler = (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid onClick={() => handleAddCust(record)} style={{ cursor: 'pointer', fontWeight: 'bold' }}>
                {record.registration}
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };
    const redirectToScreens = (record) => {
        history.push(`/Job/${record.headerRecordID}/${record.workflowID}?ProcessId=${record.processID}`);
    };

    const wipLVUHandler = (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid onClick={() => redirectToScreens(record)} style={{ cursor: 'pointer', fontWeight: 'bold' }}>
                {record.companyWIPNumber}
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const column = useMemo(() => {
        let col = [...baseColumns];

        let registrationCol = col.find((m) => m.field === 'registration');
        if (registrationCol) {
            registrationCol.renderer = registrationLVUHandler;
        }

        let actionCol = col.find((m) => m.field === 'wipNumber');
        if (actionCol) {
            actionCol.renderer = wipLVUHandler;
        }

        return col;
    }, []);

    const getUrl = `LoanVehicleUsage/GetLoanVehiclesUsage`;

    return (
        <div className="report-screen-container">
            <BreadCrumbs crumbs={crumbs()} />
            <Grid container spacing={1} style={{ padding: '10px 0px' }}>
                <Grid item xs={12}>
                    <ReportGijgoGrid
                        dataConverter={(res) => ({
                            records: res.data.list,
                            total: res.data.total
                        })}
                        columns={column}
                        getUrl={getUrl}
                        displayPagination={true}
                        dropDownListProvider={getReportsSalesDropdownsResolveData}
                    />
                </Grid>
            </Grid>

            {state.showLoanVehicleUsage && (
                <DialogComp onClose={() => closeLoanVehicleUsageModal(false)} maxWidth="xl" fullScreen overflow>
                    <LoanVehicleBooking
                        HeaderRecordID={state.selectedRecord?.headerRecordID || null}
                        LoanVehicleUsageID={state.selectedRecord?.loanVehicleUsageID}
                        onClose={closeLoanVehicleUsageModal}
                    />
                </DialogComp>
            )}
        </div>
    );
};
export default LoanVehicleUsageList;
